import { render } from "./App.vue?vue&type=template&id=2c90a86d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2c90a86d&lang=scss"

import exportComponent from "/home/pzborow/works/gunb/rwdzold/dev/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__